export class FinancePlan {
  id?: number;
  providerCode?: string;
  planCode?: string;
  planName?: string;
  termMonths?: number;
  apr?: number;
  minAmount?: number;
  maxAmount?: number;
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;

  constructor(item?: any) {
    this.update(item);
  }

  update(item?: any) {
    if (!item) {
      return;
    }

    if (item.id !== undefined) {
      this.id = item.id;
    }
    if (item.providerCode !== undefined) {
      this.providerCode = item.providerCode;
    }
    if (item.planCode !== undefined) {
      this.planCode = item.planCode;
    }
    if (item.planName !== undefined) {
      this.planName = item.planName;
    }
    if (item.termMonths !== undefined) {
      this.termMonths = item.termMonths;
    }
    if (item.apr !== undefined) {
      this.apr = item.apr;
    }
    if (item.minAmount !== undefined) {
      this.minAmount = item.minAmount;
    }
    if (item.maxAmount !== undefined) {
      this.maxAmount = item.maxAmount;
    }
    if (item.active !== undefined) {
      this.active = item.active;
    }
    if (item.createdAt !== undefined) {
      this.createdAt = item.createdAt;
    }
    if (item.updatedAt !== undefined) {
      this.updatedAt = item.updatedAt;
    }
  }
}
